import colors from './colors'

const textField = {
    style: {
        width: '100%',
    },
    underlineFocusStyle: {
        borderColor: colors.yellow,
        borderWidth: '2px',
    },
    underlineStyle: {
        borderColor: colors.yellow,
        borderWidth: '1px',
    },
    floatingLabelFocusStyle: {
        color: colors.yellow,
    },
}

const desktopTextField = Object.assign({}, textField, {
    underlineStyle: {
        borderColor: colors.grey_7,
        borderWidth: '2px',
    },
    floatingLabelFocusStyle: {
        color: colors.grey_7,
    },
})

const textArea = {
    multiLine: true,
    rows: 2,
    textareaStyle: {
        border: `2px solid ${colors.yellow}`,
        borderRadius: '8px',
        padding: '10px 11px',
    },
    underlineShow: false,
    floatingLabelStyle: {
        left: '10px',
    },
    floatingLabelFocusStyle: Object.assign({}, textField.floatingLabelFocusStyle, {
        left: '0',
    }),
    style: {
        width: '100%',
    },
}

const desktopTextArea = Object.assign({}, textArea, {
    rows: 4,
    rowsMax: 4,
    textareaStyle: {
        border: `2px solid ${colors.grey_7}`,
        borderRadius: '4px',
        fontSize: '14px',
        padding: '10px 11px',
    },
    floatingLabelFocusStyle: {
        display: 'none',
    },
    floatingLabelStyle: {
        left: '10px',
        top: '43px',
        textTransform: 'uppercase',
    },
})

export default {
    textField,
    textArea,
    desktopTextField,
    desktopTextArea,
}
